import {
    VRCORE_GET_JOB_PACKS,
    VRCORE_REMOVE_JOB_PACK,
    SET_DATE_FROM,
    SET_DATE_TO,
    VRCORE_SET_SEARCH,
    VRCORE_SET_ORDERKEY,
    VRCORE_SET_ORDERBY
} from "./types";
import firebase from "firebase/app";

export const getJobPacks = () => {
    return dispatch => {
        dispatch({ type: VRCORE_GET_JOB_PACKS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: VRCORE_GET_JOB_PACKS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/job_packs")
                        .on("value", snapshot => {
                            dispatch({
                                type: VRCORE_GET_JOB_PACKS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: VRCORE_GET_JOB_PACKS.FAIL });
        }
    };
};
export const setSearchValue = value => {
    return dispatch => {
        //Just needs to be set search it is not a rest request so doesn't have FAIL,SUCCESS,REQUEST
        dispatch({
            type: VRCORE_SET_SEARCH,
            payload: value
        });
    };
};
export const setOrderByValue = value => {
    return dispatch => {
        //Just needs to be set search it is not a rest request so doesn't have FAIL,SUCCESS,REQUEST
        dispatch({
            type: VRCORE_SET_ORDERBY,
            payload: value
        });
    };
};
export const setOrderKeyValue = value => {
    return dispatch => {
        //Just needs to be set search it is not a rest request so doesn't have FAIL,SUCCESS,REQUEST
        dispatch({
            type: VRCORE_SET_ORDERKEY,
            payload: value
        });
    };
};
export const removeJobPack = job => {
    return dispatch => {
        dispatch({ type: VRCORE_REMOVE_JOB_PACK.REQUEST });
        job.deleted = true;
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: VRCORE_REMOVE_JOB_PACK.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/subjects/job_packs/${job.job_id}/profile`)
                        .set(job);
                }
            });
        } catch (e) {
            dispatch({ type: VRCORE_REMOVE_JOB_PACK.FAIL });
        }
    };
};
export const setDateFrom = from => {
    return dispatch => {
        dispatch({ type: SET_DATE_FROM, payload: from });
    };
};
export const setDateTo = to => {
    return dispatch => {
        dispatch({ type: SET_DATE_TO, payload: to });
    };
};
